<template>
  <div>
    <v-select
      v-model="language"
      @input="handleInput"
      :label="$t('language.label')"
      :items="languageList"
      :disabled="disabled"
      item-text="text"
      item-value="value"
      outlined
    />
  </div>
</template>

<script>
import { countriesList } from '@/util/enums'

export default {
  name: 'HLanguageSelect',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    country: {
      type: String,
      required: false,
    },

    defaultValue: {
      type: String,
      required: false,
    },
  },

  computed: {
    language: {
      get() {
        if (this.defaultValue) return this.defaultValue
        if (this.country === 'BR' && !this.defaultValue) return 'PT_BR'
        return 'EN_US'
      },
      set(value) {
        return value
      }
    },

    languageList() {
      const list = []

      countriesList.map((item) => {
        list.push(
          {
            text: `${item.flag} ${item.language}`,
            value: item.code,
          }
        )
      })

      return list
    }
  },

  watch: {
    language() {
      this.$emit('input', this.language)
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
  }
}
</script>
